module.exports = __webpack_public_path__ + "static/img/avator.79001e83.svg";